import { type ReactNode, useEffect } from 'react';

import { identifyUser, initPostHog, resetIdentity } from '@/lib/analytics/posthog';

import { useAuth } from './auth-provider';

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initPostHog();
  }, []);

  const { user } = useAuth();
  useEffect(() => {
    if (user) identifyUser(user.id, { role: user.role });
    else resetIdentity();
  }, [user]);

  return <>{children}</>;
}
